export function shortId(id, length = 7) {
    if (!id) {
        return "";
    }
    return "~" + id.slice(-length);
}
export function shortenString(str, length) {
    return str.length > length ? str.substring(0, length) + '...' : str;
}
//# sourceMappingURL=text.js.map